import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuthStore } from '../../stores/useAuthStore';

export const KitchenLogin: React.FC = () => {
  const [pin, setPin] = useState('');
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  const { login } = useAuthStore();

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    setIsLoading(true);

    try {
      const success = await login('kitchen', pin);
      if (success) {
        navigate('/kitchen/display');
      } else {
        setError('קוד PIN שגוי');
        setPin('');
      }
    } catch (err) {
      setError('שגיאה בהתחברות');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-gray-900 text-white flex items-center justify-center p-4">
      <div className="max-w-lg w-full">
        <div className="card">
          <h1 className="text-3xl font-bold text-center mb-8">תצוגת מטבח</h1>

          <form onSubmit={handleSubmit}>
            <div className="mb-6">
              <label className="block text-lg font-medium mb-4">
                קוד גישה למטבח
              </label>
              <input
                type="password"
                value={pin}
                onChange={(e) => setPin(e.target.value.replace(/\D/g, ''))}
                placeholder="••••"
                maxLength={4}
                className="input-field text-center text-3xl tracking-widest"
                autoFocus
                disabled={isLoading}
              />
            </div>

            {error && (
              <div className="mb-4 p-3 bg-red-900/50 border border-red-700 rounded-lg text-center">
                <p className="text-red-400">{error}</p>
              </div>
            )}

            <button
              type="submit"
              disabled={pin.length !== 4 || isLoading}
              className="btn-primary w-full text-lg py-4 disabled:opacity-50"
            >
              {isLoading ? 'מתחבר...' : 'כניסה לתצוגה'}
            </button>
          </form>

          <button
            onClick={() => navigate('/')}
            className="btn-secondary w-full mt-4 text-lg py-4"
          >
            חזרה
          </button>
        </div>
      </div>
    </div>
  );
};